import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { get } from '../utils/get';
import { IQueryOptionsWindow } from '../models/query/options';

export class WindowQuery extends BaseQuery<IQueryOptionsWindow> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsWindow {
		const { key, keyQuery, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			...(options.window || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { key } = this.options;
		return get(global, key);
	}
}